import { DateRange } from '@logz-pkg/utils';
import { QuickOption } from '../types';

const isQuickOptionSelected = ({
  id,
  start,
  end,
  value,
  selectedDate,
}: {
  id?: string;
  start: QuickOption['start'];
  end: QuickOption['end'];
  value?: DateRange;
  selectedDate: (DateRange & { id?: string; skipConfirm?: boolean }) | null;
}): boolean => {
  if (selectedDate?.id) {
    return selectedDate.id === id;
  }

  const startValue = typeof start === 'function' ? start() : start;
  const endValue = typeof end === 'function' ? end() : end;

  return startValue === value?.start.value && endValue === value?.end.value;
};

export const quickFilterUtils = {
  isQuickOptionSelected,
};
